import React, { useContext } from 'react';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { IParagraph } from '../../../../utils/types/contentful';
import { LocalContext } from '../../../../utils/providers/locale';
import { nodes } from './body.utils';

const options = () => ({
  renderNode: nodes,
});

export interface IBodyProps extends IParagraph {
  locale?: string;
}

export const Body = ({ richBody }: IBodyProps) => {
  const locale = useContext(LocalContext)[0];
  const contentfulLocal = () => {
    const arr = locale.toLowerCase().split('-');
    return `${arr[0]}${arr[1] && `-${arr[1].toUpperCase()}`}`;
  };

  const key = contentfulLocal().includes('en') ? 'en' : contentfulLocal();
  return richBody ? (
    <>{renderRichText(richBody, options(locale, key))}</>
  ) : (
    <></>
  );
};

export const ContentfulBody = ({ body }) => {
  return <Body {...body} />;
};
